
import { useContext } from '@nuxtjs/composition-api'
import { Pages } from '~/assets/ts/pages'

export default {
  setup() {
    const {
      app: { i18n, router },
    } = useContext()

    let pageRoute = '' as string | null | undefined
    let pageName = '' as string
    let pageStr = '' as string

    const PagesHelper = new Pages()
    pageRoute = PagesHelper.getPageRoute(router)
    pageName = PagesHelper.getPageName(pageRoute)
    pageStr = PagesHelper.getPageStr(pageName)

    return {
      i18n,
      pageRoute,
      pageName,
      pageStr,
    }
  },
}
